export const checkoutUrl = 'https://ninja-coach-ready.impultienda.ar/checkout'

export const productName = 'Ninja Coach Ready™'

export const ctaLabel = '🔴 GET THE COMPLETE COACHING SYSTEM NOW'

export const heroImage =
  'https://cdn.magicpatterns.com/uploads/r8UzNExbs5VxLBp58PjSat/Diseno_sin_titulo_(62).png'

export const price = {
  regular: 'USD 99.00',
  today: 'USD 27.00',
  value: 27,
}

export const comboIncludes = [
  '150 Ninja classes ready to teach',
  '6 complete coaching volumes',
  '40+ weeks with no repeats',
  'Every class completely structured',
  'Scripts, cues, and progressions included',
  'Bonus 1 — 52 weekly coaching themes',
  'Bonus 2 — Definitive Coaching Cues Library',
  'Bonus 3 — Adaptation & Regression Guide',
  'Bonus 4 — 50 emergency classes',
  'Bonus 5 — Ninja Class Search System',
  '7-day money-back guarantee',
]

export const finalIncludes = [
  ...comboIncludes,
  'Immediate access',
  'Pay in your local currency',
  'Ready-to-use PDF format',
]

export function trackCheckout() {
  window.fbq?.('track', 'InitiateCheckout', {
    content_name: 'Ninja Coach Ready Complete Coaching System',
    value: price.value,
    currency: 'USD',
  })
}
